import { LayoutComponent } from "@jelly/lesson";
import variables from "../../../../../../../assets/styles/sass-resources.scss";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 1,
        rows: 2,
        rowsSize: [1.5, 1],
        gap: "10px",
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/case01/slide05-validation-image.svg`,
                    styles: {
                      height: "180px",
                      alignSelf: "flex-end",
                    },
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    scrollbars: false,
                    data:
                      "The applicability of the metrics for unknown measurement data is tested within a cross-validation loop characterizing the robustness of the metrics. In cross-validation, the initial jury test dataset is split into training and validation datasets. After creating the SQ metrics based on the available training data, the remaining validation data is used to test the prediction accuracy of the metric for unknown input.",
                    styles: {
                      fontSize: "12px",
                      fontWeight: 600,
                      width: "300px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                },
              },
            },
          ],
        ],
      },
      styles: {
        borderBottom: `solid 1px ${variables["default-light"]}`,
      },
    },
  },
];

export default components;
